import { FetchClient } from "../utils/fetchClient"

export async function getPlacesAutocomplete(input = "", sessionToken = "", lat = "", long = "", radius = "") {
    return await FetchClient(`/data/places-autocomplete?input=${input}&sessionToken=${sessionToken}&lat=${lat}&long=${long}&radius=${radius}`).GET({})
}

export async function getPlaceDetails(placeId = "", sessionToken = "") {
    return await FetchClient(`/data/place-details?placeId=${placeId}&sessionToken=${sessionToken}`).GET({})
}
